export type AppRole = 'viewer' | 'contributor' | 'admin';

export type RoleAction =
  | 'audit:read'
  | 'field-options:manage'
  | 'product-activity:read'
  | 'product-lifecycle:manage'
  | 'product-status:filter'
  | 'submissions:bulk-review'
  | 'submissions:review'
  | 'upc:bulk-field-import'
  | 'upc:mass-edit';

const ACTION_MIN_ROLE: Record<RoleAction, AppRole> = {
  'audit:read': 'admin',
  'field-options:manage': 'contributor',
  'product-activity:read': 'admin',
  'product-lifecycle:manage': 'admin',
  'product-status:filter': 'admin',
  'submissions:bulk-review': 'admin',
  'submissions:review': 'admin',
  'upc:bulk-field-import': 'admin',
  'upc:mass-edit': 'admin',
};

const ROLE_LEVEL: Record<AppRole, number> = {
  viewer: 0,
  contributor: 1,
  admin: 2,
};

export const ROLE_LABEL: Record<AppRole, string> = {
  viewer: 'User',
  contributor: 'UPC Manager',
  admin: 'Admin',
};

export const isAppRole = (role: string | null | undefined): role is AppRole =>
  role === 'viewer' || role === 'contributor' || role === 'admin';

export const canRole = (role: string | null | undefined, action: RoleAction): boolean => {
  if (!isAppRole(role)) return false;
  return ROLE_LEVEL[role] >= ROLE_LEVEL[ACTION_MIN_ROLE[action]];
};

export const getRoleLabel = (role: string | null | undefined): string =>
  isAppRole(role) ? ROLE_LABEL[role] : 'User';
